import React from "react";
import { useTranslation } from "../lib/translations";

interface PageLoaderProps {
  text?: string;
  progress?: number;
}

export function PageLoader({ text, progress }: PageLoaderProps) {
  const { language } = useTranslation();
  return (
    <div className="fixed inset-0 bg-[#020617] flex flex-col items-center justify-center text-center gap-6 overflow-hidden z-50 animate-fade-in">
      {/* Glowing game token/card spinner */}
      <div className="game-spinner">
        <div className="tile-segment"></div>
        <div className="tile-segment"></div>
        <div className="tile-segment"></div>
        <div className="tile-segment"></div>
        <div className="tile-segment"></div>
        <div className="tile-segment"></div>
        <div className="tile-segment"></div>
        <div className="tile-segment"></div>
      </div>
      
      <div className="flex flex-col gap-1">
        <h1 className="brand-text">pisti.online</h1>
        <span className="brand-sub">
          {language === 'tr' ? 'YÜKLENİYOR' : 'LOADING'}
          {typeof progress === 'number' && ` (${Math.round(progress)}%)`}
        </span>
      </div>

      <div className="loading-bar-container">
        <div 
          className="loading-bar"
          style={typeof progress === 'number' ? { width: `${progress}%`, animation: 'none' } : {}}
        ></div>
      </div>

      <span className="loading-tip">
        {text || (language === 'tr' ? 'Güvenli bağlantı kuruluyor...' : 'Establishing secure connection...')}
      </span>
    </div>
  );
}
